var map = {
	"./Anny.jpg": "022e",
	"./David.jpg": "ffe0",
	"./Lorraine.jpg": "a800",
	"./Mark.jpg": "f132",
	"./Mint.jpg": "ba26",
	"./Ra.jpg": "f971"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05ba";